export const USER_INFO = 'USER_INFO'
export const RECORD_INFO = 'RECORD_INFO'
export const CURRENT_CHANNEL = 'CURRENT_CHANNEL'
export const CHANNEL_LIST = 'CHANNEL_LIST'
export const NEWS_LIST = 'NEWS_LIST'
export const CURRENT_NEWS = 'CURRENT_NEWS'
export const CURRENT_APP = 'CURRENT_APP'
